import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

//@ts-ignore
import Modal from 'live/components/ui/Modal'
import SpreadSheetOption from './SpreadsheetOptions'
import getDatabase from '../../../actionCreators/getDatabaseHeaders'
import selectSheet from '../../../actionCreators/selectSheet'
import dismissModal from '../../../actionCreators/dismissModal'
import ModalPreview from '../../preview/ModalPreview'

//@ts-ignore
import i18n from 'live/services/i18n'
import getDatabaseHeaders from '../../../api/getDatabaseHeaders'
import { Database } from '../EditDatabase/EditDatabase'
import { DEFAULT_DATASOURCE } from '../../../lib/constants'
// import './modalFull.css'
// import'../../preview/preview.scss'

interface Props {
    model: string
    open: (type: string) => void
    hide: () => void
    show: boolean
}

function ShowDatabase({ model, hide, open, show }: Props) {
    const [database, setDatabase] = useState<Database>(DEFAULT_DATASOURCE)
    useEffect(() => {
        if (show) {
            getDatabaseHeaders(model).then((database: Database) => {
                setDatabase(database)
            })
        }
    }, [show])

    return (
        <li
            onClick={() => {
                if (!show) open(model)
            }} 
            >
            <SpreadSheetOption icon="eye"  text={i18n('View Database')}
                 onClick={() => {}} />
            <Modal
                show={show}
                onHide={hide} 
                onClose={hide}
                backdrop="static"
                keyboard={false}
                className="showDatabase2"
            >
                <Modal.Header style={{ backgroundColor: 'var(--gray-0)' }} closeButton>
                    <Modal.Title>{model}</Modal.Title>
                </Modal.Header>

                <ModalPreview headers={database?.headers} onlyView={true} />

                <Modal.Footer>
                    <Button onClick={hide}>Close</Button>
                </Modal.Footer>
            </Modal>
        </li>
    )
}

const Button = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 27px; 

    color: white;

    font-family: 'Source Sans Pro', sans-serif; 
    font-style: normal;
    font-weight: 700;
    font-size: 15px;

    border: none;

    background: #37a3ef;
    border-radius: 3px;
`


function mapStateToProps({ sheet }) {
    const { headers, database, showModalDatabase } = sheet

    return {
        headers,
        database,
        showModalDatabase
    }
}

export default connect(mapStateToProps, { selectSheet, getDatabase, dismissModal })(ShowDatabase)
